import React from "react"; // This is actually used. It's just not detected by the linter
import { StyleSheet, View, ViewStyle } from "react-native";
import variables from "../../styles/variables";

export type GapSize = keyof (typeof variables)["spacing"];

type Props = {
  vertical?: boolean;
  size?: GapSize;
  style?: ViewStyle | ViewStyle[];
};

/**
 * A simple component to add horizontal or vertical gaps between elements.
 * @param {boolean} [props.vertical] - If true, creates a vertical gap.
 * @param {GapSize} [props.size="small"] - The size of the gap.
 * @param {Object} [props.style] - Additional styles to apply.
 *
 * @returns {JSX.Element} A View component that serves as a gap.
 *
 * @example
 * // Horizontal gap of medium size
 * <Gap size="medium" />
 *
 * @example
 * // Vertical gap of large size
 * <Gap vertical size="large" />
 */
const Gap: React.FC<Props> = ({
  vertical,
  size = "small",
  style,
}: Props): JSX.Element => (
  <View
    style={[
      styles.gap,
      vertical
        ? { height: variables["spacing"][size] }
        : { width: variables["spacing"][size] },
      style,
    ]}
  />
);

const styles = StyleSheet.create({
  gap: { backgroundColor: "transparent" },
});

export default Gap;
